export default {
  /**
   * Returns all the dataSources available in [dataSources]
   * @param {Store.state} state
   */
  getDataSources: state => {
    return state.dataSourcesById.map(dsId => state.dataSources[dsId]);
  },
  /**
   * Returns details of a single datasource from [dataSources]
   * @param {Store.state} state
   * @param {String} tablename
   */
  getDataSourceDetails: state => {
    return datasource_id => {
      return state.dataSources[datasource_id];
    };
  },
};
